import React from "react";

const AudioVisualizer = ({ isPlaying = false, barCount = 5 }) => {
  return (
    <div className="flex items-center justify-center gap-1 h-8">
      {Array.from({ length: barCount }).map((_, i) => (
        <div
          key={i}
          className={`w-1 bg-gradient-to-t from-violet-600 to-cyan-400 rounded-full transition-all duration-200 ${
            isPlaying ? 'wave-bar' : ''
          }`}
          style={{ 
            height: isPlaying ? undefined : '8px',
            animationDelay: `${i * 0.1}s`
          }}
        />
      ))}
    </div>
  );
};

export default AudioVisualizer;
